import { DataTransform } from '../dataTransform';
import { TransformType } from '../transformType';
import { DataFarmType } from '../dataFarmType';
import { SortInfo } from '../sortInfo';
import { DuplicateKeep, DuplicateType } from 'src/app/views/transform/transformerDetail/column-cleaner-transform-detail/columnCleanerRuleViewModel';

export class JoinerTransform extends DataTransform<JoinerTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.farmJoiner,nodeID);
      this.transformConfig = new JoinerTransformConfig();
    }

    static fromJSON(data: any): JoinerTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: JoinerTransform = Object.assign(new JoinerTransform(0, 0, '', ''), data);
        instance.transformConfig = JoinerTransformConfig.fromJSON(instance.transformConfig);

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        //this.transformConfig.runAll = runAll;
    }
}

export class JoinerTransformConfig {
    farmType: DataFarmType;
    transformType: TransformType;
    sortInfo?: SortInfo[];
    sampleStart: number;
    sampleEnd: number;
    reserialzeJids: boolean=false;
    resetRows:boolean;
    runDedup: boolean;
   // mergeOption:MergeOption[];
     mergeOption:MergeOption[];
    //rules: JoinerTransformRule[];
    fieldMap: JoinerTransformMapper[];
    fieldList?: string[];
    duplicatesType: DuplicateType;
    duplicatesKeep: DuplicateKeep;

    static fromJSON(data: any): JoinerTransformConfig {
        //console.log(`fromJson invoked: ${data}`);
        const instance: JoinerTransformConfig = Object.assign(new JoinerTransformConfig(), data);

        // const rules: JoinerTransformRule[] = [];

        // if (instance.rules) {
        //     instance.rules.forEach(r => {
        //         const rule = JoinerTransformRule.fromJSON(r);
        //         rules.push(rule);
        //     });
        // }
        // instance.rules = rules;

          const mergeOption: MergeOption[] = [];

        if (instance.mergeOption) {
            instance.mergeOption.forEach(r => {
                const moptions = MergeOption.fromJSON(r);
                mergeOption.push(moptions);
            });
        }
        instance.mergeOption = mergeOption;

        const fieldMap: JoinerTransformMapper[] = [];

        if (instance.fieldMap) {
            instance.fieldMap.forEach(r => {
                const mapper = JoinerTransformMapper.fromJSON(r);
                fieldMap.push(mapper);
            });
        }
        instance.fieldMap = fieldMap;

        return instance;
    }
}

export class JoinerTransformRule {
    index: number;
    fieldList?: string[];
    duplicatesKeep : DuplicatesKeep;
    run: boolean;
    static fromJSON(data: any): JoinerTransformRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: JoinerTransformRule = Object.assign(new JoinerTransformRule(), data);

        return instance;
    }
}
export class JoinerTransformMapper {
    nodeID:string;
    index: number;
    indexName:string;
    nodeColor:string;
    nodeFields:string;
    nodeName:string;
    nodeNo:string;
    nodeRows:string;
    nodeCoordinate:string;
    mapTable:JoinerMapper[];

    static fromJSON(data: any): JoinerTransformMapper {
        //console.log(`fromJson invoked: ${data}`);
        const instance: JoinerTransformMapper = Object.assign(new JoinerTransformMapper(), data);

        return instance;
    }
}
export class JoinerMapper {
    field: string;
    mapTo: string;
  }

export enum DuplicatesKeep {
    first = 0,
    last = 1,
    noRows = 2
}
export class DuplicatesKeepUtil {
    static toString(duplicatesKeep:DuplicatesKeep): string {
        switch (duplicatesKeep) {
            case DuplicatesKeep.first: return 'First';
            case DuplicatesKeep.last: return 'Last';
            case DuplicatesKeep.noRows: return 'No Rows';
        }
}
}
/*export class MergeOption {
    state: boolean
    field: string
    nodeColor:string

}*/

export class MergeOption {
    state: boolean
    field: string
    nodeColor:string


    static fromJSON(data: any): MergeOption {
        //console.log(`fromJson invoked: ${data}`);
        const instance: MergeOption = Object.assign(new MergeOption(), data);

        return instance;
    }
}